import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef} from 'react';
import {useHeaderComponent} from "../hooks/useHeaderComponent";
import {InputSwitch} from "primereact/inputswitch";

interface Props {

}

export const IsLiveInputSwitch : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    const {isLiveState, updateIsLive} = useHeaderComponent();

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    return <div className={'flex align-items-center gap-3'}><label>{f({id: isLiveState.isOnline ? 'onlineLive' : 'live'})}</label><InputSwitch checked={isLiveState.isLive} onChange={e => updateIsLive({isLive: e.value, isButtonClicked: true})} /></div>
};
